export const API_URL = "https://dummyjson.com/products";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 4;
